import * as React from "react";

function ExpandIcon(props) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			width="1em"
			height="1em"
			{...props}
		>
			<path
				fill="none"
				stroke="currentColor"
				strokeWidth="2"
				d="m18 17l-6-6l-6 6M7 6h10"
			></path>
		</svg>
	);
}

export default ExpandIcon;
